export default {
    road_line: {
        name: "Road Line",
        url: "nwcg_lines_repair/road_line",
    },
    road_repair: {
        name: "Road Repair",
        url: "nwcg_lines_repair/road_repair",
    },
}
